import React, { useEffect } from 'react'
import { labels } from '../../../labels'
import SvgIcon, { iconNames } from '../../svgIcon/SvgIcon'
import styles from './massiveUploadConfirm.module.css'

interface IMassiveUploadConfirmProps {
    onContinue: () => void
    onClose: () => void
    haveAllFiles: boolean
}

const WithoutAllFiles = () => {
    return (
        <div style={{ color: '#656565', marginBottom: 30, lineHeight: 1.5 }}>
            {labels.suggest} {labels.attachImages}
            <br />
            (Archivo ZIP).
            <br />
            {labels.publishWithoutImages} <br />{' '}
            <i style={{ fontWeight: '600' }}>{labels.amipass}</i>{' '}
            {labels.bussinessHours}
        </div>
    )
}

export default function MassiveUploadConfirm({
    onContinue,
    onClose,
    haveAllFiles,
}: IMassiveUploadConfirmProps) {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }, [])
    return (
        <div className={styles.container}>
            <div className={styles.icon}>
                {haveAllFiles ? (
                    <SvgIcon
                        iconName={
                            haveAllFiles
                                ? iconNames.circleClock
                                : iconNames.warningImages
                        }
                    />
                ) : (
                    <img
                        src={require('../../../assets/images/warning-no-prod.png')}
                        width="120"
                    />
                )}
            </div>
            {haveAllFiles ? (
                <p className="Body1-16">
                    {labels.team}{' '}
                    <b>
                        <i>{labels.amipass}</i>
                    </b>{' '}
                    {labels.massiveConfirm}
                </p>
            ) : (
                <WithoutAllFiles />
            )}
            <b style={{ color: '#656565' }}>{labels.wantContinue}</b>
            <div className={styles.buttons}>
                <button onClick={onClose} className={styles.buttonBack}>
                    {labels.back}
                </button>
                <button
                    onClick={onContinue}
                    className={
                        haveAllFiles
                            ? styles.buttonContinue
                            : `${styles.buttonContinue} ${styles.withoutImagesButton}`
                    }
                >
                    {haveAllFiles
                        ? labels.continue
                        : labels.buttonPublishWithoutImages}
                </button>
            </div>
        </div>
    )
}
